import React, { useState, useRef, useEffect } from "react";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import "./JDSearchResults.scss";
import { getFieldStyle } from "../../themes";

export default function JDSearchResults({ data, all, index }) {
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const parentPath = pathSegments[1];

  useEffect(() => {}, []);

  const handleJDClick = (id) => {
    navigate(`/${parentPath}/${id}`);
  };

  return (
    <div className="JDSearchResult-wrapper">
      <div className="JDSearchResult-title-wrapper">
        <div
          className="param_wrapper_0"
          onClick={() => handleJDClick(data.QhCompanyJID)}
        >
          <div
            className="param_wrapper_0_0"
            onClick={() => handleJDClick(data.QhCompanyJID)}
            style={{ cursor: "pointer" }}
          >
            {index + 1}
            {". "}
            {
              data.JDProject.ReqType != "customer_project"?
              <>
              </>
              :<>
                <span className="param_info">
                  {"[ " + data.JDClient?.ClientName + " / "}
                  {data.JDClient?.TaName + " ] "}
                </span>
                <span className="param_info">
                  {"[ " + data.JDClient?.ClientJobType + " / "}
                  {data.JDDetails?.JobType + " ] "}
                </span>  
                <span className="param_info">
                  {"[ " + data.JDClient?.EndClient + " ] "}
                </span>  
                <span className="param_info">
                  {"[ " + data.JDRequired?.MinExperience +" Yr - "+ data.JDRequired?.MaxExperience+ " Yr ] "}
                </span> 
                <span className="param_info">
                  {"[ " + data.JDRequired?.NoticePeriod+ " Days ]"}
                </span>     
                <span className="param_info">
                  {"[ " + data.JDProject?.MinCtc +" LPA - "+ data.JDProject?.MaxCtc+ " LPA ] "}
                </span>                                                            
                <span className="param_info">
                  {" [" + data.QhCompanyJID + "]  "}{" "}
                </span>
                <span
                  className="param_info jd_priority"
                  style={getFieldStyle("jdPriority", data.JDOther?.Priority)}
                >
                  {" [" + data.JDOther?.Priority + "]      "}{" "}
                </span>{" "}
                {data.JDDetails?.Title}              
              </>
            }
          </div>
          <div className="param_wrapper_0_1">
           <div
              style={{
                backgroundColor: "#fff",
                marginRight: "5px",
                borderRadius: "6px",
              }}
            >           
              <div
                className="jd_status"
              >
                {data.version}
              </div>
            </div>            
            <div
              style={{
                backgroundColor: "#fff",
                marginRight: "5px",
                borderRadius: "6px",
              }}
            >           
            <div
                className="jd_status"
                style={getFieldStyle("jdPermission", data.JDDetails.JobPermission)}
              >
                {data.JDDetails.JobPermission}
              </div>   
            </div>

            <div
              style={{
                backgroundColor: "#fff",
                marginRight: "5px",
                borderRadius: "6px",
              }}
            >
              <div
                className="jd_status"
                style={getFieldStyle("jdStatus", data.JDProject?.ReqStatus)}
              >
                {data.JDProject?.ReqStatus}
              </div>
            </div>
            <span className="param_info_end">
              {data.spoc == ""
                ? "SPOC : Not Assigned"
                : "SPOC : " + data.JDAssignment?.Spoc}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
